import incomeExpenditurePage from './incomeExpenditurePage';

export default incomeExpenditurePage;
